import { render } from "./GpsView.vue?vue&type=template&id=820190c2"
import script from "./GpsView.vue?vue&type=script&lang=js"
export * from "./GpsView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__